import { Action } from '@ngrx/store';
import { AusmitError } from "../../shared/interfaces";
import { CriteriaModel } from "../../shared/interfaces/CriteriaModel";

export enum ActionTypes {
	GetAllTypes = 'GetAllTypes',
	GetAllTypesSuccess = 'GetAllTypesSuccess',
	GetAllTypesError = 'GetAllTypesError',

	GetItemsByStoreId = 'GetItemsByStoreId',
	GetItemsByStoreIdSuccess = 'GetItemsByStoreIdSuccess',
	GetItemsByStoreIdError = 'GetItemsByStoreIdError',

	GetItem = 'GetItem',
	GetItemSuccess = 'GetItemSuccess',
	GetItemError = 'GetItemError',

	GetItems = 'GetItems',
	GetItemsSuccess = 'GetItemsSuccess',
	GetItemsError = 'GetItemsError',

	ItemPostComment = 'ItemPostComment',
	ItemPostCommentSuccess = 'ItemPostCommentSuccess',
	ItemPostCommentError = 'ItemPostCommentError',
	ItemPostCommentReset = 'ItemPostCommentReset',

	LikeItem = 'LikeItem',
	DisLikeItem = 'DisLikeItem',
	LikeItemSuccess = 'LikeItemSuccess',
	LikeItemError = 'LikeItemError',
	LikeItemReset = 'LikeItemReset',

	ClearGetItem = 'ClearGetItem',

	CompareItems = 'CompareItems',
	CompareItemsSuccess = 'CompareItemsSuccess',
	CompareItemsError = 'CompareItemsError',

	AddToCartItem = 'AddToCartItem',
	AddToCartItemSuccess = 'AddToCartItemSuccess',
	AddToCartItemError = 'AddToCartItemError',

	GetItemFromCart = 'GetItemFromCart',
	GetItemFromCartSuccess = 'GetItemFromCartSuccess',
	GetItemFromCartError = 'GetItemFromCartError',

	DeleteItemFromCart = 'DeleteItemFromCart',
	DeleteItemFromCartSuccess = 'DeleteItemFromCartSuccess',
	DeleteItemFromCartError = 'DeleteItemFromCartError',

	RemoveItemFromCart = 'RemoveItemFromCart',
	RemoveItemFromCartSuccess = 'RemoveItemFromCartSuccess',
	RemoveItemFromCartError = 'RemoveItemFromCartError',

	GetCheckoutData = 'GetCheckoutData',
	GetCheckoutDataSuccess = 'GetCheckoutDataSuccess',
	GetCheckoutDataError = 'GetCheckoutDataError',

	phItemPaymentStatus = 'phItemPaymentStatus',
	phItemPaymentStatusSuccess = 'phItemPaymentStatusSuccess',
	phItemPaymentStatusError = 'phItemPaymentStatusError',

	GetAllCustomJewellery = 'GetAllCustomJewellery',
	GetAllCustomJewellerySuccess = 'GetAllCustomJewellerySuccess',
	GetAllCustomJewelleryError = 'GetAllCustomJewelleryError',

	CustomJewelleryCheckOutDetail = 'CustomJewelleryCheckOutDetail',
	CustomJewelleryCheckOutDetailSuccess = 'CustomJewelleryCheckOutDetailSuccess',
	CustomJewelleryCheckOutDetailError = 'CustomJewelleryCheckOutDetailError',

	CustomJewelleryPaymentStatus = 'CustomJewelleryPaymentStatus',
	CustomJewelleryPaymentStatusSuccess = 'CustomJewelleryPaymentStatusSuccess',
	CustomJewelleryPaymentStatusError = 'CustomJewelleryPaymentStatusError',

	CheckCustomJewPaymentType = 'CheckCustomJewPaymentType',
	CheckCustomJewPaymentTypeSuccess = 'CheckCustomJewPaymentTypeSuccess',
	CheckCustomJewPaymentTypeError = 'CheckCustomJewPaymentTypeError',

	GetReview = 'GetReview',
	GetReviewSuccess = 'GetReviewSuccess',
	GetReviewError = 'GetReviewError',

	GetAllItemsForWeb = 'GetAllItemsForWeb',
	GetAllItemsForWebSuccess = 'GetAllItemsForWebSuccess',
	GetAllItemsForWebError = 'GetAllItemsForWebError',

	GetStoreItemsForWeb = 'GetStoreItemsForWeb',
	GetStoreItemsForWebSuccess = 'GetStoreItemsForWebSuccess',
	GetStoreItemsForWebError = 'GetStoreItemsForWebError',

	GetCustomJewelleryPriceDetails = 'GetCustomJewelleryPriceDetails',
	GetCustomJewelleryPriceDetailsSuccess = 'GetCustomJewelleryPriceDetailsSuccess',
	GetCustomJewelleryPriceDetailsError = 'GetCustomJewelleryPriceDetailsError',

	GetAllCompareData = 'GetAllCompareData',
	GetAllCompareDataSuccess = 'GetAllCompareDataSuccess',
	GetAllCompareDataError = 'GetAllCompareDataError',

	CheckServiceAbility = 'CheckServiceAbility',
	CheckServiceAbilitySuccess = 'CheckServiceAbilitySuccess',
	CheckServiceAbilityError = 'CheckServiceAbilityError',

	CountTotalItem = 'CountTotalItem',
	CountTotalItemSuccess = 'CountTotalItemSuccess',
	CountTotalItemError = 'CountTotalItemError',
}

export class GetAllTypes implements Action {
	readonly type = ActionTypes.GetAllTypes;

	constructor(public payload?: any) {
	}
}

export class GetAllTypesSuccess implements Action {
	readonly type = ActionTypes.GetAllTypesSuccess;

	constructor(public payload: any) {
	}
}

export class GetAllTypesError implements Action {
	readonly type = ActionTypes.GetAllTypesError;

	constructor(public payload: AusmitError) {
	}
}

export class GetItemsByStoreId implements Action {
	readonly type = ActionTypes.GetItemsByStoreId;

	constructor(public payload: {
		storeId: string,
		criteria: CriteriaModel,
	}) {
	}
}

export class GetItemsByStoreIdSuccess implements Action {
	readonly type = ActionTypes.GetItemsByStoreIdSuccess;

	constructor(public payload: any) {
	}
}

export class GetItemsByStoreIdError implements Action {
	readonly type = ActionTypes.GetItemsByStoreIdError;

	constructor(public payload: AusmitError) {
	}
}

export class GetItem implements Action {
	readonly type = ActionTypes.GetItem;

	constructor(public payload: { itemId: string }) {
	}
}

export class GetItemSuccess implements Action {
	readonly type = ActionTypes.GetItemSuccess;

	constructor(public payload: any) {
	}
}

export class GetItemError implements Action {
	readonly type = ActionTypes.GetItemError;

	constructor(public payload: AusmitError) {
	}
}

export class GetItems implements Action {
	readonly type = ActionTypes.GetItems;

	constructor(public payload: CriteriaModel) {
	}
}

export class GetItemsSuccess implements Action {
	readonly type = ActionTypes.GetItemsSuccess;

	constructor(public payload: any) {
	}
}

export class GetItemsError implements Action {
	readonly type = ActionTypes.GetItemsError;

	constructor(public payload: AusmitError) {
	}
}

export class ItemPostComment implements Action {
	readonly type = ActionTypes.ItemPostComment;

	constructor(public payload: { itemId: string; payload: any }) {
	}
}

export class ItemPostCommentSuccess implements Action {
	readonly type = ActionTypes.ItemPostCommentSuccess;

	constructor(public payload: any) {
	}
}

export class ItemPostCommentError implements Action {
	readonly type = ActionTypes.ItemPostCommentError;

	constructor(public payload: AusmitError) {
	}
}

export class ItemPostCommentReset implements Action {
	readonly type = ActionTypes.ItemPostCommentReset;

	constructor() {
	}
}

export class LikeItem implements Action {
	readonly type = ActionTypes.LikeItem;

	constructor(public payload: { itemId: string }) {
	}
}

export class DisLikeItem implements Action {
	readonly type = ActionTypes.DisLikeItem;

	constructor(public payload: { itemId: string; likeId: string }) {
	}
}

export class LikeItemSuccess implements Action {
	readonly type = ActionTypes.LikeItemSuccess;

	constructor(public payload: any) {
	}
}

export class LikeItemError implements Action {
	readonly type = ActionTypes.LikeItemError;

	constructor(public payload: AusmitError) {
	}
}

export class LikeItemReset implements Action {
	readonly type = ActionTypes.LikeItemReset;

	constructor() {
	}
}

export class ClearGetItem implements Action {
	readonly type = ActionTypes.ClearGetItem;

	constructor() {
	}
}

export class CompareItems implements Action {
	readonly type = ActionTypes.CompareItems;

	constructor(public payload: any) {
	}
}

export class CompareItemsSuccess implements Action {
	readonly type = ActionTypes.CompareItemsSuccess;

	constructor(public payload: any) {
	}
}

export class CompareItemsError implements Action {
	readonly type = ActionTypes.CompareItemsError;

	constructor(public payload: AusmitError) {
	}
}

export class AddToCartItem implements Action {
	readonly type = ActionTypes.AddToCartItem;

	constructor(public payload: { variationId: string; quantity: number, storeId: string }) {
	}
}

export class AddToCartItemSuccess implements Action {
	readonly type = ActionTypes.AddToCartItemSuccess;

	constructor(public payload: any) {
	}
}

export class AddToCartItemError implements Action {
	readonly type = ActionTypes.AddToCartItemError;

	constructor(public payload: AusmitError) {
	}
}

export class GetItemFromCart implements Action {
	readonly type = ActionTypes.GetItemFromCart;

	constructor(public payload: any) {
	}
}

export class GetItemFromCartSuccess implements Action {
	readonly type = ActionTypes.GetItemFromCartSuccess;

	constructor(public payload: any) {
	}
}

export class GetItemFromCartError implements Action {
	readonly type = ActionTypes.GetItemFromCartError;

	constructor(public payload: AusmitError) {
	}
}

export class DeleteItemFromCart implements Action {
	readonly type = ActionTypes.DeleteItemFromCart;

	constructor(public payload: null) {
	}
}

export class DeleteItemFromCartSuccess implements Action {
	readonly type = ActionTypes.DeleteItemFromCartSuccess;

	constructor(public payload: null) {
	}
}

export class DeleteItemFromCartError implements Action {
	readonly type = ActionTypes.DeleteItemFromCartError;

	constructor(public payload: AusmitError) {
	}
}

export class RemoveItemFromCart implements Action {
	readonly type = ActionTypes.RemoveItemFromCart;

	constructor(public payload: { variationId: string; }) {
	}
}

export class RemoveItemFromCartSuccess implements Action {
	readonly type = ActionTypes.RemoveItemFromCartSuccess;

	constructor(public payload: any) {
	}
}

export class RemoveItemFromCartError implements Action {
	readonly type = ActionTypes.RemoveItemFromCartError;

	constructor(public payload: AusmitError) {
	}
}

export class GetCheckoutData implements Action {
	readonly type = ActionTypes.GetCheckoutData;

	constructor(public payload: any) {
	}
}

export class GetCheckoutDataSuccess implements Action {
	readonly type = ActionTypes.GetCheckoutDataSuccess;

	constructor(public payload: any) {
	}
}

export class GetCheckoutDataError implements Action {
	readonly type = ActionTypes.GetCheckoutDataError;

	constructor(public payload: AusmitError) {
	}
}

export class phItemPaymentStatus implements Action {
	readonly type = ActionTypes.phItemPaymentStatus;

	constructor(public payload: any) {
	}
}

export class phItemPaymentStatusSuccess implements Action {
	readonly type = ActionTypes.phItemPaymentStatusSuccess;

	constructor(public payload: any) {
	}
}

export class phItemPaymentStatusError implements Action {
	readonly type = ActionTypes.phItemPaymentStatusError;

	constructor(public payload: AusmitError) {
	}
}

export class GetAllCustomJewellery implements Action {
	readonly type = ActionTypes.GetAllCustomJewellery;
	constructor(public payload: any) {
	}
}

export class GetAllCustomJewellerySuccess implements Action {
	readonly type = ActionTypes.GetAllCustomJewellerySuccess;

	constructor(public payload: any) {
	}
}
export class GetAllCustomJewelleryError implements Action {

	readonly type = ActionTypes.GetAllCustomJewelleryError;
	constructor(public payload: AusmitError) {
	}
}

export class GetReview implements Action {
	readonly type = ActionTypes.GetReview;

	constructor(public payload: CriteriaModel) {
	}
}

export class GetReviewSuccess implements Action {
	readonly type = ActionTypes.GetReviewSuccess;

	constructor(public payload: any) {
	}
}

export class GetReviewError implements Action {
	readonly type = ActionTypes.GetReviewError;

	constructor(public payload: AusmitError) {
	}
}

export class GetAllItemsForWeb implements Action {
	readonly type = ActionTypes.GetAllItemsForWeb;

	constructor(public payload: CriteriaModel) {
	}
}

export class GetAllItemsForWebSuccess implements Action {
	readonly type = ActionTypes.GetAllItemsForWebSuccess;

	constructor(public payload: any) {
	}
}

export class GetAllItemsForWebError implements Action {
	readonly type = ActionTypes.GetAllItemsForWebError;

	constructor(public payload: AusmitError) {
	}
}

export class CustomJewelleryCheckOutDetail implements Action {
	readonly type = ActionTypes.CustomJewelleryCheckOutDetail;
	constructor(public payload: any) {
	}
}

export class CustomJewelleryCheckOutDetailSuccess implements Action {
	readonly type = ActionTypes.CustomJewelleryCheckOutDetailSuccess;

	constructor(public payload: any) {
	}
}
export class CustomJewelleryCheckOutDetailError implements Action {

	readonly type = ActionTypes.CustomJewelleryCheckOutDetailError;

	constructor(public payload: AusmitError) {
	}
}

export class CustomJewelleryPaymentStatus implements Action {
	readonly type = ActionTypes.CustomJewelleryPaymentStatus;

	constructor(public payload: any) {
	}
}

export class CustomJewelleryPaymentStatusSuccess implements Action {
	readonly type = ActionTypes.CustomJewelleryPaymentStatusSuccess;

	constructor(public payload: any) {
	}
}

export class CustomJewelleryPaymentStatusError implements Action {
	readonly type = ActionTypes.CustomJewelleryPaymentStatusError;

	constructor(public payload: AusmitError) {
	}
}

export class CheckCustomJewPaymentType implements Action {
	readonly type = ActionTypes.CheckCustomJewPaymentType;

	constructor(public payload: any) {
	}
}

export class CheckCustomJewPaymentTypeSuccess implements Action {
	readonly type = ActionTypes.CheckCustomJewPaymentTypeSuccess;

	constructor(public payload: any) {
	}
}

export class CheckCustomJewPaymentTypeError implements Action {
	readonly type = ActionTypes.CheckCustomJewPaymentTypeError;
	constructor(public payload: AusmitError) {
	}
}

export class GetStoreItemsForWeb implements Action {
	readonly type = ActionTypes.GetStoreItemsForWeb;

	constructor(public payload: {
		storeId: string,
		criteria: CriteriaModel,
	}) {
	}
}

export class GetStoreItemsForWebSuccess implements Action {
	readonly type = ActionTypes.GetStoreItemsForWebSuccess;

	constructor(public payload: any) {
	}
}

export class GetStoreItemsForWebError implements Action {
	readonly type = ActionTypes.GetStoreItemsForWebError;

	constructor(public payload: AusmitError) {
	}
}
export class GetCustomJewelleryPriceDetails implements Action {
	readonly type = ActionTypes.GetCustomJewelleryPriceDetails;

	constructor(public payload: any) {
	}
}

export class GetCustomJewelleryPriceDetailsSuccess implements Action {
	readonly type = ActionTypes.GetCustomJewelleryPriceDetailsSuccess;

	constructor(public payload: any) {
	}
}

export class GetCustomJewelleryPriceDetailsError implements Action {
	readonly type = ActionTypes.GetCustomJewelleryPriceDetailsError;

	constructor(public payload: AusmitError) {
	}
}

export class GetAllCompareData implements Action {
	readonly type = ActionTypes.GetAllCompareData;

	constructor(public payload: any) {
	}
}

export class GetAllCompareDataSuccess implements Action {
	readonly type = ActionTypes.GetAllCompareDataSuccess;

	constructor(public payload: any) {
	}
}

export class GetAllCompareDataError implements Action {
	readonly type = ActionTypes.GetAllCompareDataError;

	constructor(public payload: AusmitError) {
	}
}

export class CheckServiceAbility implements Action {
	readonly type = ActionTypes.CheckServiceAbility;

	constructor(public payload: any) {
	}
}

export class CheckServiceAbilitySuccess implements Action {
	readonly type = ActionTypes.CheckServiceAbilitySuccess;

	constructor(public payload: any) {
	}
}

export class CheckServiceAbilityError implements Action {
	readonly type = ActionTypes.CheckServiceAbilityError;

	constructor(public payload: AusmitError) {
	}
}

export class CountTotalItem implements Action {
	readonly type = ActionTypes.CountTotalItem;

	constructor(public payload: any) {
	}
}

export class CountTotalItemSuccess implements Action {
	readonly type = ActionTypes.CountTotalItemSuccess;

	constructor(public payload: any) {
	}
}

export class CountTotalItemError implements Action {
	readonly type = ActionTypes.CountTotalItemError;

	constructor(public payload: AusmitError) {
	}
}

export type Actions =
	| GetAllTypes
	| GetAllTypesSuccess
	| GetAllTypesError
	| GetItemsByStoreId
	| GetItemsByStoreIdSuccess
	| GetItemsByStoreIdError
	| GetItem
	| GetItemSuccess
	| GetItemError
	| GetItems
	| GetItemsSuccess
	| GetItemsError
	| ItemPostComment
	| ItemPostCommentSuccess
	| ItemPostCommentError
	| ItemPostCommentReset
	| LikeItem
	| LikeItemSuccess
	| LikeItemError
	| LikeItemReset
	| DisLikeItem
	| ClearGetItem
	| CompareItems
	| CompareItemsSuccess
	| CompareItemsError
	| AddToCartItem
	| AddToCartItemSuccess
	| AddToCartItemError
	| GetItemFromCart
	| GetItemFromCartSuccess
	| GetItemFromCartError
	| DeleteItemFromCart
	| DeleteItemFromCartSuccess
	| DeleteItemFromCartError
	| RemoveItemFromCart
	| RemoveItemFromCartSuccess
	| RemoveItemFromCartError
	| GetCheckoutData
	| GetCheckoutDataSuccess
	| GetCheckoutDataError
	| phItemPaymentStatus
	| phItemPaymentStatusSuccess
	| phItemPaymentStatusError
	| GetAllCustomJewellery
	| GetAllCustomJewellerySuccess
	| GetAllCustomJewelleryError
	| CustomJewelleryCheckOutDetail
	| CustomJewelleryCheckOutDetailSuccess
	| CustomJewelleryCheckOutDetailError
	| CustomJewelleryPaymentStatus
	| CustomJewelleryPaymentStatusSuccess
	| CustomJewelleryPaymentStatusError
	| CheckCustomJewPaymentType
	| CheckCustomJewPaymentTypeSuccess
	| CheckCustomJewPaymentTypeError
	| GetReview
	| GetReviewSuccess
	| GetReviewError
	| GetAllItemsForWeb
	| GetAllItemsForWebSuccess
	| GetAllItemsForWebError
	| GetStoreItemsForWeb
	| GetStoreItemsForWebSuccess
	| GetStoreItemsForWebError
	| GetCustomJewelleryPriceDetails
	| GetCustomJewelleryPriceDetailsSuccess
	| GetCustomJewelleryPriceDetailsError
	| GetAllCompareData
	| GetAllCompareDataSuccess
	| GetAllCompareDataError
	| CheckServiceAbility
	| CheckServiceAbilitySuccess
	| CheckServiceAbilityError
	| CountTotalItem
	| CountTotalItemSuccess
	| CountTotalItemError;

